import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 28,

    display: 'flex',
    flexDirection: 'column',
  },
  card: {
    padding: theme.spacing(1),
    borderRadius: 4,
    border: '1px solid #ECEFF1',
    marginBottom: theme.spacing(2),
  },
  cardHeader: {
    padding: '11px 7px',
    borderBottom: '1px solid #ECEFF1',
  },
  productName: {
    fontSize: 14,
    color: '#37474F',
    fontWeight: 600,
  },
  cardContent: {
    padding: '11px 7px 7px',

    display: 'flex',
    flexDirection: 'column',
  },
  detailKey: {
    fontSize: 16,
    color: '#37474F',
    fontWeight: 600,

    '& + strong': {
      marginTop: theme.spacing(1),
    },
  },
  detailValue: {
    fontSize: 14,
    color: '#546E7A',
    fontWeight: 400,
  },
}));
